import { motion } from "framer-motion";
import { BookOpen, Wand2, PartyPopper } from "lucide-react";


export default function ServicesSection() {
  const cards = [
    {
      title: "Eventos",
      title2: "literarios",
      text: "Creamos experiencias únicas donde los cuentos cobran vida.",
      img: "/img/cuadernos.jpg",
      inverted: false,
      url:"/eventos",
      icon: BookOpen,
    },
    {
      title: "Celebraciones",
      article: "a",
      title2: "Medida",
      text: "Diseñamos contigo cada detalle de tu celebración soñada.",
      img: "/img/mesa.webp",
      inverted: true,
      url:"/celebraciones",
      icon: PartyPopper,
    },
    {
      title: "Bailes",
      article: "De",
      title2: "Fantasía",
      text: "Noches mágicas llenas de baile, música y cuentos.",
      img: "/img/eventos.jpg",
      inverted: false,
      url:"/bailes",
      icon: Wand2,
    },
    
    

  ];

  return (
    <section id="servicios" className="bg-eryndra-forest px-4 md:px-8 text-center my-20">
  {/* FICHAS para MÓVIL */}
  <div className="grid grid-cols-1 gap-6 max-w-xl mx-auto lg:hidden">
  {cards.map((card, index) => {
    const Icon = card.icon;
    return (
      <a
        key={index}
        href={card.url}
        className="border border-eryndra-gold rounded-lg p-6 shadow-md bg-eryndra-forest text-eryndra-gold"
      >
        <div className="flex justify-center mb-4">
          <Icon className="w-8 h-8 text-eryndra-gold" />
        </div>
        <h2 className="text-xl font-bold uppercase text-eryndra-gold text-center">{card.title}</h2>
        {card.article && (
          <h3 className="text-md font-semibold uppercase text-center">{card.article}</h3>
        )}
        {card.title2 && (
          <h2 className="text-xl font-bold uppercase text-center">{card.title2}</h2>
        )}
        <p className="mt-2 text-sm text-eryndra-cream text-center">{card.text}</p>
      </a>
    );
  })}
  </div>

  {/* PÍLDORAS para DESKTOP */}
  <div className="hidden lg:grid grid-cols-3 gap-8 max-w-6xl mx-auto">
    {cards.map((card, index) => (
      <motion.div
        key={index}
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        whileHover={{ scale: 1.05 }}
        viewport={{ once: true }}
        transition={{ duration: 0.3 }}
        className="flex flex-col items-center"
      >
        <a href={card.url}>
          <div className="cursor-pointer rounded-full overflow-hidden shadow-lg">
            {!card.inverted && (
              <>
                <div className="relative w-full h-[13.75rem] md:h-[16.25rem] rounded-t-full border border-eryndra-gold bg-gradient-to-b from-eryndra-ivory/10 to-eryndra-forest backdrop-blur-md overflow-hidden">
                  <div className="py-12 px-4">
                    <h1 className="text-eryndra-gold text-2xl md:text-4xl uppercase">{card.title}</h1>
                    {card.article && (
                      <h1 className="text-eryndra-gold text-lg uppercase">{card.article}</h1>
                    )}
                    {card.title2 && (
                      <h1 className="text-eryndra-gold text-2xl md:text-4xl uppercase mb-4">
                        {card.title2}
                      </h1>
                    )}
                    <p className="px-4 font-bellefair text-md md:text-xl text-eryndra-cream">{card.text}</p>
                  </div>
                </div>
                <div className="mt-2 relative w-full h-[13.75rem] md:h-[16.25rem] rounded-b-full bg-eryndra-ivory/10 backdrop-blur-md shadow-lg overflow-hidden">
                  <img src={card.img} alt={card.title} className="w-full h-full object-cover" />
                </div>
              </>
            )}

            {card.inverted && (
              <>
                <div className="mb-2 relative w-full h-[13.75rem] md:h-[16.25rem] rounded-t-full bg-eryndra-ivory/10 backdrop-blur-md shadow-lg overflow-hidden">
                  <img src={card.img} alt={card.title} className="w-full h-full object-cover" />
                </div>
                <div className="relative w-full h-[13.75rem] md:h-[16.25rem] rounded-b-full border border-eryndra-gold bg-gradient-to-b to-eryndra-ivory/10 from-eryndra-forest backdrop-blur-md shadow-lg overflow-hidden">
                  <div className="py-9 px-6">
                    <h1 className="text-eryndra-gold text-2xl md:text-4xl uppercase">{card.title}</h1>
                    {card.article && (
                      <h1 className="text-eryndra-gold text-lg uppercase">{card.article}</h1>
                    )}
                    {card.title2 && (
                      <h1 className="text-eryndra-gold text-2xl md:text-4xl uppercase mb-4">
                        {card.title2}
                      </h1>
                    )}
                    <p className="px-4 font-bellefair text-md md:text-lg text-eryndra-cream">{card.text}</p>
                  </div>
                </div>
              </>
            )}
          </div>
        </a>
      </motion.div>
    ))}
  </div>
</section>

    // <section id="servicios" className="bg-eryndra-forest px-8 h-[33rem]  text-center h-movil my-20">
    //      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto ">
    //     {cards.map((card, index) => (
    //       <motion.div
    //         key={index}
    //         initial={{ opacity: 0, y: 20 }}
    //         whileInView={{ opacity: 1, y: 0 }}
    //         whileHover={{ scale: 1.05 }}
    //         viewport={{ once: true }}
    //         transition={{ duration: 0.3 }}
    //         className={"flex flex-col items-center"}
    //       >
    //        {/* Imagen abajo si está invertida */}
    //             {!card.inverted && (
    //               <a href={card.url}>
    //                 <div className="cursor-pointer  rounded-t-[9999px] rounded-b-[9999px]">
    //                     <div className="relative w-full h-[13.75rem] md:h-[16.25rem] rounded-t-[9999px] border border-eryndra-gold bg-gradient-to-b from-eryndra-ivory/10 to-eryndra-forest backdrop-blur-md shadow-lg  overflow-hidden ">
                            
    //                         <div className="py-5 px-1 md:px-4 md:py-10">
    //                             <h1 className="text-eryndra-gold text-2xl md:text-4xl uppercase  ">
    //                                 {card.title}
    //                             </h1>
    //                             <h1 className="text-eryndra-gold text-lg uppercase  ">
    //                                 {card.article}
    //                             </h1>
    //                             <h1 className="text-eryndra-gold text-2xl md:text-4xl uppercase  mb-4">
    //                                 {card.title2}
    //                             </h1>
    //                             <p className="px-10 font-bellefair text-md lg:text-xl md:text-md sm:text-sm text-eryndra-cream text-card">
    //                                 {card.text}
    //                             </p>
    //                         </div>
    //                     </div> 
    //                     <div className="mt-2 relative w-full h-[13.75rem] md:h-[16.25rem] rounded-b-[9999px] bg-eryndra-ivory/10 backdrop-blur-md shadow-lg  overflow-hidden ">   
    //                         <div className="w-full h-[13.75rem] md:h-[16.25rem] overflow-hidden ">
    //                         <   img src={card.img} loading="eager" alt={card.title} className="w-full h-[13.75rem] md:h-[19.25rem] object-cover" />
    //                         </div>
    //                     </div>
    //                 </div>
    //                 </a>  
    //             )}

            
    //         {/* Imagen arriba si está invertida */}
    //         {card.inverted && (
    //           <a href={card.url}>
    //             <div className="cursor-pointer  rounded-t-[9999px] rounded-b-[9999px]">
    //                 <div className="mb-2 relative w-full h-[13.75rem] md:h-[16.25rem] rounded-t-[9999px] bg-eryndra-ivory/10 backdrop-blur-md shadow-lg  overflow-hidden ">   
    //                 <div className="w-full h-[13.75rem] md:h-[16.25rem] overflow-hidden ">
    //                 <   img src={card.img} alt={card.title} className="w-full h-full h-[13.75rem] md:h-[19.25rem] object-cover" />
    //                 </div>
    //             </div>
    //             <div className="relative w-full h-[13.75rem] md:h-[16.25rem] rounded-b-[9999px] border border-eryndra-gold bg-gradient-to-b to-eryndra-ivory/10 from-eryndra-forest backdrop-blur-md shadow-lg  overflow-hidden ">
                    
    //                 <div className="py-9 px-1 md:px-4">
    //                     <h1 className="text-eryndra-gold text-2xl md:text-4xl uppercase  ">
    //                         {card.title}
    //                     </h1>
    //                     <h1 className="text-eryndra-gold text-lg uppercase  ">
    //                         {card.article}
    //                     </h1>
    //                     <h1 className="text-eryndra-gold text-2xl md:text-4xl uppercase  mb-4">
    //                         {card.title2}
    //                     </h1>
    //                     <p className="px-10 font-bellefair text-md lg:text-xl md:text-md sm:text-sm text-eryndra-cream text-card">
    //                         {card.text}
    //                     </p>
    //                 </div>
    //             </div> 
                
    //         </div>
    //         </a>
    //         )}
    //       </motion.div>
    //     ))}
    //   </div>    
    // </section>
  );
}

  